import { Route, Switch } from "react-router";
import IssuesTable from "./IssuesTable";
import IssuesForm from "./IssuesForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/issues" component={IssuesTable} />
    <WriteRoute
      exact
      path="/issues/addnew"
      component={IssuesForm}
      redirectTo="/issues"
    />
  </Switch>
);
